import cookie from 'react-cookies'
import axios from 'axios';
import { Notification } from '@arco-design/web-react';

let commonstring = {
    ip: 'http://localhost:5000/op',
    cookie_bk_uid: 'staffname',
}

export function GetUserInfo(){
    const userInfo = {}
    userInfo.userNameEn = cookie.load(commonstring.cookie_bk_uid);

    return userInfo;
}

export function GetLanguageFolder(language){
    let languageFolder = ''
    if(language == 'de'){
        languageFolder = 'de/'
    }else if(language == 'en'){
        languageFolder = 'en/'
    }
    return languageFolder
}

export function GetMenuList(language){
    let menuList = [
        // {title: '首页', buttonText:'', url: '/',},
        {title: '公司介绍', buttonText:'公司介绍', url: '/page2',},
        {title: '音乐表演', buttonText:'音乐表演', url: '/page3',},
        {title: '音乐教育', buttonText:'音乐教育', url: '/page4',},
        {title: '音乐科技', buttonText:'音乐科技', url: '/page5',},
        {title: '新闻中心', buttonText:'新闻中心', url: '/page6',},
        // {title: '中/EN', buttonText:'发布进展', url: '/page6',},
      ]

    if(language == 'ch'){

    }else if(language == 'en'){
        menuList = [
            // {title: '首页', buttonText:'', url: '/',},
            {title: 'About Us', buttonText:'About Us', url: '/page2',},
            {title: 'Music Performance', buttonText:'Music Performance', url: '/page3',},
            {title: 'Music Education', buttonText:'Music Education', url: '/page4',},
            {title: 'Music Technology', buttonText:'Music Technology', url: '/page5',},
            {title: 'News Center', buttonText:'News Center', url: '/page6',},
            // {title: '中/EN', buttonText:'发布进展', url: '/page6',},
          ]
    }else if(language == 'de'){
        menuList = [
            // {title: '首页', buttonText:'', url: '/',},
            {title: 'Über uns', buttonText:'Über uns', url: '/page2',},
            {title: 'Musikaufführung', buttonText:'Musikaufführung', url: '/page3',},
            {title: 'Musikausbildung', buttonText:'Musikausbildung', url: '/page4',},
            {title: 'Musiktechnologie', buttonText:'Musiktechnologie', url: '/page5',},
            {title: 'Nachrichten', buttonText:'Nachrichten', url: '/page6',},
            // {title: '中/EN', buttonText:'发布进展', url: '/page6',},
          ]
    }

    return menuList
}

export function hasLogin(){
    let userName = GetUserInfo().userNameEn
    if(userName && userName!= ''){
        return true
    }
    return false
}

export function Login(userId){
    cookie.save(commonstring.cookie_bk_uid, userId)
}

export function Logout(){
    // cookie.remove(commonstring.cookie_bk_uid)
    let list = cookie.loadAll()
    for(var key in list){
        cookie.remove(key)
    }
	
	let reqData = {}
	
	// SendMsg(commonstring.url_LOGOUT, reqData)
    axios.post(commonstring.ip, reqData)
    .then(response => {
        const rspData = response.data
		window.location.href = rspData.url
    })
    .catch((error) => {
        console.log(error);
		Notification.success({
			title: 'Error',
			content: "catch error",
		})
    })
}

export function getLocalTimeStr(t){
    if(!t){
        return ''
    }
    let d = new Date(t)
    let timestr = d.toLocaleDateString() +' '+d.toLocaleTimeString()
    return timestr
}

export async function SendMsg(reqData, successFunc, failFunc){
    // if(!GetUserInfo().userNameEn){
    //     return
    // }
    return failFunc('error')
    const userName = GetUserInfo().userNameEn || '未登录'
    reqData.userId = userName
    // if(!reqData.branch){
    //     let branch = GetBranch()
    //     reqData.branch = GetDBName(branch)
    // }
    

    axios.post(commonstring.ip, reqData)
    .then(response => {
        const rspData = response.data
        console.log(reqData, response)
        if(response.data.success)
        {
            if(successFunc){
                successFunc(rspData)
            }
        }
        else
        {
            console.log(reqData, response)
            if(failFunc){
                failFunc(rspData)
            }else{
                Notification.error({
                    title: 'Error',
                    content: rspData.log,
                })
            }
        }
    })
    .catch((error) => {
        console.log(error);
        if(failFunc){
            failFunc(error)
        }else{
            Notification.error({
                title: 'Error',
                content: "出现了一个错误，请联系toxicwang",
            })
        }
    })
}

export function hasVerticalScrollbar() {
    return document.body.scrollHeight > window.innerHeight;
}

export function openUrl(url, jump=null){
    window.open(url, '_blank', jump);
}